module.exports = __webpack_public_path__ + "static/media/wsa_logo_2015_rgb_branca.fc1e8845.png";